module.exports = __webpack_public_path__ + "static/media/display14.3c78099d.jpg";